// extracted by mini-css-extract-plugin
module.exports = {"error":"_Tender2__error___1TRXs"};